<template>
    <div v-if="startsDate" data-testid="mkt-date-time-range" class="mkt-date">
        <VJoyIcon name="calendar" :color="iconColor" />
        {{ formattedEventDate }}
    </div>
</template>

<script setup lang="ts">
    import {capitalize, computed} from 'vue';
    import {useFormat} from '#imports';
    import {VJoyIcon} from '@maltjoy/core-vue';
    import {useVariants} from '../../composables/useVariants';

    type MktDateTimeProps = {
        startsDate: Date;
        endsDate?: Date;
    };

    const props = defineProps<MktDateTimeProps>();

    const {icon: iconColor} = useVariants();
    const {formatDate, formatTimeToShort} = useFormat();

    const endsTime = computed(() => formatTimeToShort(props.endsDate));

    const startsDateWithStartingTime = computed(() => capitalize(formatDate(props.startsDate, {dateStyle: 'full', timeStyle: 'short'})));

    const formattedEventDate = computed(() => {
        if (props.endsDate) {
            return `${startsDateWithStartingTime.value} - ${endsTime.value}`;
        }

        return startsDateWithStartingTime.value;
    });
</script>
<style scoped lang="scss">
    .mkt-date {
        display: flex;
        align-items: center;
        gap: var(--joy-core-spacing-1);
    }
</style>
